<template>
    <b-card no-body class="v2_box_teal border-0 shadow-none phairify-card">
      <component
        :is="userRole"
        :save-loading="saveLoading"
        :is-header-visible="false"
        ref="form"
        @profileFormCancel="onProfileFormCancel"
        @profileFormSubmit="onProfileFormSubmit"
        @validate-failed="$emit('validate-failed')"
        :selectedProfileQuestions="selectedProfileQuestions ? selectedProfileQuestions : []"
        :fromPriorStudy="true"
      />
    </b-card>
  </template>
  
  <script>
  import GetMembershipTypeOptionsMixin from '@/mixins/GetMembershipTypeOptionsMixin';
  import GetMemberTypeMappingOptionsMixin from '@/mixins/GetMemberTypeMappingOptionsMixin';
  import UpdateUserProfileMssUserForm from '@/components/users/profile/forms/UpdateUserProfileMssUserForm';
  import Api from '@/providers/Api';
  import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
  
  export default {
    name: 'UpdateProfileFormForStudy',
    mixins: [GetMembershipTypeOptionsMixin, GetMemberTypeMappingOptionsMixin],
    components: {
      UpdateUserProfileMssUserForm
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      selectedProfileQuestions: Array,
      fromPriorStudy: Boolean
    },
    data: function () {
      return {
        saveLoading: false,
      };
    },
    computed: {
      user: function () {
        return this.$store.state.user ? this.$store.state.user : {};
      },
      userRole: function () {
        return UpdateUserProfileMssUserForm.name;
      },
    },
    methods: {
      save: function () {
        this.$refs.form &&
          typeof this.$refs.form.onSubmit === 'function' &&
          this.$refs.form.onSubmit();
      },
      onProfileFormCancel: function () {
        this.$emit('close');
      },
      onProfileFormSubmit: async function (userData) {
        try {
          this.saveLoading = true;
  
          await Api.updateUserProfile(userData, true);
  
          this.$toasted.success('Profile is updated', {
            duration: 3000,
          });
          if(this.fromPriorStudy){
            this.$emit('on-user-profile-save');
          }else{
            this.$emit('profile-form-submit');
          }
        } catch (error) {
          handleServerErrorWithValidation(error, this.$toasted);
        } finally {
          this.saveLoading = false;
        }
      },
    },
  };
  </script>
  
  <style lang="scss">
    .form-row {
      div.col {
        flex-direction: column;
        align-items: start;
        justify-content: center;
      }
    }
  </style>
  